import { _getDetail, _prepareForm, clearForms } from '../Forms/duck';

import APICall from '$ReduxLegacy/Actions/APICall';
import Unireducer from '$ReduxLegacy/Reducers/Factories/Unireducer';

// Consider moving to utils??
export const _isFailure = data => data.type === 'API_FAILURE';

//Cycling through the other actions
export const getCompleteReview = () => async dispatch => {
    // These will have been marked as complete for the previous section;
    // We need to clear that out so the post-review forms will show.
    dispatch(clearForms());

    const reviewData = await _getReview(dispatch);

    if (_isFailure(reviewData)) return;

    const formsPromises = reviewData.response.results.map(form => {
        const { title, slug } = form.fobi_form;
        form.title = title;
        return _getDetail(slug, dispatch)
            .then(data => {
                return _prepareForm(data.response, form, form.data, true);
            })
            .catch(function (err) {
                console.error(
                    `An error occured with the form ${title} and it can't be shown for review.`,
                    err
                );
            });
    });

    //we can use Promise.all b/c of the catch!
    //http://adampaxton.com/handling-multiple-javascript-promises-even-if-some-fail/
    return Promise.all(formsPromises).then(formsArray => {
        return dispatch({
            type: '@@REVIEW/CHANGE',
            payload: formsArray
        });
    });
};

// For internal use-- exported *only* for TESTING!
// If you try to use these directly as actions, they will *fail*

export const _getReview = dispatch => {
    return dispatch(
        APICall({
            type: 'GET',
            url: '/api/v2/forms/review/'
        })
    );
};

//THIS MUST BE USED WITH THE KEY 'review' ONLY
export default Unireducer('@@REVIEW', null);
